//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProjectSelct from "../components/projectSelct";
import util from '@/lib/util';
import BottomNav from "../components/BottomNav";

export default {
    name: "projectProgress",
    components: {
        ProjectSelct,
        BottomNav,
    },
    data() {
        return {
            processImg: require('@/assets/img/banner-index1.jpg'),
            refreshing: false,
            pageIndex: 1,
            pageSize: 10,
            loading: false,
            finished: false,
            downloadUrl: util.ApiUrl + '/file/download/',
            projectId: 0,
            list: [],
            year: 0,
            month: 0
        }
    },
    methods: {
        onLoad() {
            // if (pageIndex == 1) {
            //     return
            // }
            this.pageIndex++;
            this.getProgress()
        },
        getProgress() {
            if (this.projectId == 0) {
                return
            }
            var page = {
                auditStatus: 1,
                maxResultCount: this.pageSize,
                skipCount: (this.pageIndex - 1) * this.pageSize,
                projectId: this.projectId,
                year: this.year,
                month: this.month,
            };
            abp.ajax.post('/api/services/app/ProjectProgress/SearchProjectProgresses', page).then((res) => {
                if (this.pageIndex === 1) {
                    this.list = [];
                }
                this.list.push(...res.data.result.items);
                if (res.data.result.items.length < this.pageSize) {
                    this.finished = true;
                } else {
                    this.finished = false;
                }
            }).catch((error) => {
                // console.log('111111');
                // console.log(error);
                this.loading = true;
            }).then(() => {
                this.refreshing = false;
                this.loading = false;
            }).finally(() => {
                // this.refreshing = false;
                // this.loading = true;
            });
        },
        projectChange(id) {
            this.projectId = id;
            this.list = [];
            this.pageIndex = 1;
            this.getProgress();
        },
        onClicked(item) {
            if (item.contentType == 0) {
                this.$router.push('/progressDetail/' + item.id);
                // :to="{path:'/progressDetail/'+item.id}"
            } else if (item.contentType == 1 && item.source != null) {
                if (item.source.substr(0, 4) == 'http') {
                    window.open(item.source);
                } else {
                    window.open('http://' + item.source);
                }
            } else {
                // this.$router.push('/contentDetail/' + content.id);
            }

        },
    },
    created() {
        this.loading = true;
        this.projectId = parseInt(this.$route.params.projectId) || 0;
        this.year = this.$route.params.year;
        this.month = this.$route.params.month;
        if (this.projectId > 0) {
            this.getProgress();
        }
    }
}


